import state from './moduleCrewLaborTemplateState.js'
import mutations from './moduleCrewLaborTemplateMutations.js'
import actions from './moduleCrewLaborTemplateActions.js'
import getters from './moduleCrewLaborTemplateGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
